export default "__VITE_ASSET__CT5$zp_z__"